import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class Survey extends BaseModel {
    @Expose() id = 0;
    @Expose() question = "";
    @Expose() comment = "";
    @Expose() answer = "";
    @Expose() registerDate = "";
    @Expose() userIdentity = "";
}
